import { Hourglass } from 'lucide-react';

import type { ApplyCloseType } from '@/types/receipt';

import { StatusTag } from './StatusTag';

interface EarlyCloseHintProps {
  applyCloseType?: ApplyCloseType | null;
  compact?: boolean;
}

/**
 * 사업 단위 조기 마감 표시(specs/078 FR-013) — 예보 접수 종료 방식이 "조기 마감 가능"인 사업 행에 붙인다. 공고 단위 상태는
 * `ReceiptStatusBadge` 가 담당한다.
 */
export function EarlyCloseHint({ applyCloseType, compact = false }: EarlyCloseHintProps) {
  if (applyCloseType !== 'EARLY_CLOSE_POSSIBLE') return null;
  return (
    <StatusTag tone="warning" title="예산 소진 시 조기 마감될 수 있어요">
      <Hourglass className={compact ? 'size-3' : undefined} aria-hidden="true" />
      조기 마감 가능
    </StatusTag>
  );
}
